import type { DocEntityType } from "building-types/doc/docEntityTypes";
import type { DocRef } from "building-types/docRef";

export enum IntegrityIssueType {
  DOC_EMPTY = "DOC_EMPTY",
  INVALID_REFERENCE = "INVALID_REFERENCE",
  INVALID_SELF_REFERENCE = "INVALID_SELF_REFERENCE",
  INVALID_DOC_ENTITY = "INVALID_DOC_ENTITY",
  INVALID_DOC_VERSION = "INVALID_DOC_VERSION",
  KEY_ID_MISMATCH = "KEY_ID_MISMATCH",
  ELEVATION_MIRROR_DESYNC = "ELEVATION_MIRROR_DESYNC",
}

interface BaseIntegrityInfo {
  readonly srcHash: string;
  readonly dstHash: string;
  readonly srcEntityType: DocEntityType;
  readonly dstEntityType: DocEntityType;
  readonly docRef: DocRef;
}

export interface BaseIntegrityIssue extends Partial<BaseIntegrityInfo> {
  readonly type: IntegrityIssueType;
  readonly message: string;
}

export type DocIntegrityIssue =
  | DocEmpty
  | InvalidReference
  | InvalidSelfReference
  | InvalidDocEntity
  | InvalidDocVersion
  | KeyIdMismatch
  | ElevationMirrorDesync;

export interface DocEmpty extends BaseIntegrityIssue {
  readonly type: IntegrityIssueType.DOC_EMPTY;
}

export interface InvalidReference extends BaseIntegrityIssue {
  readonly type: IntegrityIssueType.INVALID_REFERENCE;
}

export interface InvalidSelfReference extends BaseIntegrityIssue {
  readonly type: IntegrityIssueType.INVALID_SELF_REFERENCE;
}

export interface InvalidDocEntity extends BaseIntegrityIssue {
  readonly type: IntegrityIssueType.INVALID_DOC_ENTITY;
}

export interface KeyIdMismatch extends BaseIntegrityIssue {
  readonly type: IntegrityIssueType.KEY_ID_MISMATCH;
  readonly tableName: string;
  readonly key: string;
  readonly id: string;
}

/**
 * `doc.optionSets.elevationStyle` no longer reproduces itself from `doc.elevations`. The two tables
 * are redundant and every elevation write has to move both; this reports the one that did not.
 */
export interface ElevationMirrorDesync extends BaseIntegrityIssue {
  readonly type: IntegrityIssueType.ELEVATION_MIRROR_DESYNC;
}

export interface InvalidDocVersion extends BaseIntegrityIssue {
  readonly type: IntegrityIssueType.INVALID_DOC_VERSION;
  readonly content: any;
}
